import { TFunction } from "i18next";
import { KitchenTypeEnum } from "./interfaces";

export interface KitchenTypeOption {
  value: KitchenTypeEnum;
  key: string;
}

export const kitchenTypeOptions: KitchenTypeOption[] = Object.keys(
  KitchenTypeEnum
)
  .filter((key) => isNaN(Number(key)))
  .map((key) => ({ value: KitchenTypeEnum[key], key }));

// Kitchen types without a translation fall back to their enum key, e.g. FAST_FOOD → Fast food
export const getKitchenTypeLabel = (
  t: TFunction,
  option: KitchenTypeOption
) => {
  const fallback = option.key.replace(/_/g, " ").toLowerCase();
  return t(`kitchenTypes.${option.key.toLowerCase()}`, {
    defaultValue: fallback.charAt(0).toUpperCase() + fallback.slice(1),
  });
};
